import ReactPlayer from 'react-player'
import React, { useState, useEffect } from 'react'
// import { Dialog, DialogContent } from '@mui/material'
import { useOutletContext } from 'react-router-dom'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import { castPhotos, galleryPhotos } from '../data'
import Video from 'yet-another-react-lightbox/plugins/video'
import logo from '../logo.png'
const videoUrl = 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/Girl-with-Piano-Trailer-no-text.mp4'


const ContactForm = () => {
  // const { isMobile } = useOutletContext()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('submitting');
    try {
      const response = await fetch('https://api.thegirlandherpiano.com/api/contact-form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      if (response.ok) {
        console.log('Form submitted successfully');
        setFormData({ name: '', email: '', message: '' });
        setSubmitStatus('success');
        setTimeout(() => setSubmitStatus(null), 5000); // Clear success message after 5 seconds
      } else {
        console.error('Form submission failed');
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="contact-form">
      <div className="form-group" style={{ justifyContent: 'space-between' }}>
        <div>
          <label htmlFor="name" className="form-label">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="form-input"
            placeholder="Enter your name"
          />
        </div>
        <div>
          <label htmlFor="email" className="form-label">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="form-input"
            placeholder="Enter your email"
          />
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="message" className="form-label">Message</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          className="form-textarea"
          placeholder="Enter your message"
          rows="5"
        ></textarea>
      </div>
      <button type="submit" className="submit-button" disabled={submitStatus === 'submitting'}>
        {submitStatus === 'submitting' ? 'Sending...' : 'Send Message'}
      </button>
      {submitStatus === 'success' && (
        <div className="success-message">Thank you for your message. We'll get back to you soon!</div>
      )}
      {submitStatus === 'error' && (
        <div className="error-message">An error occurred. Please try again later.</div>
      )}
    </form>
  );
};

const Trailer = ({ setShowTrailer, isMobile, isLandscape }) => {
  const [playing, setPlaying] = useState(false)
  return (
    <header className={`trailer-header ${isMobile ? 'mobile' : ''} ${isLandscape ? 'landscape' : ''}`}>
      <div className='bg-vid'
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        onMouseEnter={() => { if (!isMobile) { setPlaying(true) } }}
        onClick={() => { if (isMobile) { setShowTrailer(true) } else { setPlaying(true) } }}>
        <ReactPlayer
          config={ { file: { attributes: { poster: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/header-bg.jpg' } } } }
          url={videoUrl} width='100%' height='100%' style={{ position: 'absolute', top: 0, left: 0 }} playing={playing} loop muted />
      </div>
      <div className={`video-overlay ${isMobile ? 'mobile' : ''}`}>
        <div className='overlay-content'>
          <div className='flex-grid'>
            <div className='grid-item header-title'>
              <img src={logo} alt='The Girl and Her Piano' className='header-logo'/>
            </div>
            <div className='grid-item trailer-info'>
              <div className={`horizontal-grid ${isMobile ? 'mobile' : ''}`}>
                <div className='grid-item narrator-info-grid-item'>
                  <div><button className='trailer-button' onClick={() => setShowTrailer(true)} style={{ pointerEvents: 'initial' }}>
                    Watch Trailer
                  </button></div>
                </div>
                <div className='grid-item'>
                </div>
              </div>
              <div className='film-details-container'>
                <h3 className='film-details'>SHORT DOCUMENTARY . 11m . 2024</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

const PhotoWithContent = ({ slide, items, isMobile }) => {
  return (
    <div className={`photo-with-content ${isMobile ? 'mobile' : ''}`}>
      <div className='photo-with-content-grid'>
        <div className='photo-with-content-photo'>
          {slide.link ? (
            <a href={slide.link} target="_blank" rel="noopener noreferrer">
              <img src={slide.src} alt={slide.alt} />
            </a>
          ) : (
            <img src={slide.src} alt={slide.alt} />
          )}
        </div>
        <div className='photo-with-content-text'>
          <h1>{slide.title}</h1>
          <div>{slide.content}
            {slide.link && (<div className='link'><a href={slide.link}>{slide.link}</a></div>)}
          </div>
        </div>
      </div>
    </div>
  )
}

const PhotoGrid = ({ photos, renderPhoto, maxPhotos }) => {
  const [open, setOpen] = useState(false)
  const [items, setItems] = useState([])
  const [index, setIndex] = useState(-1)
  const [isHidden, setIsHidden] = useState(true)
  useEffect(() => {
    if (photos.length > 0) {
      const slides = photos.map((photo) => {
        const item = { ...photo }
        if (photo.content) {
          item.type = 'custom-slide'
        }
        return item
      })
      // console.log(slides)
      setItems(slides)
    }
  }, [photos])
  let props = {
    index,
    open,
    close: () => {
      setOpen(false)
      setIndex(-1)
    },
    slides: items,
    render: {
      slide: ({ slide }) => renderPhoto ? renderPhoto({ slide, items }) : null
    }
  }
  return (
    <>
      <div className='photo-grid'>
        {photos.map((photo, index) => {
          let className = 'photo-item-container'
          if (index > (maxPhotos - 1) && isHidden) {
            className += ' hide'
          }
          return (
            <div className={className} key={`photo-item-${index}`}>
              <div className='photo-item-wrapper'>
                <div 
                  className='photo-item'
                  onClick={() => {
                    setIndex(index)
                    setOpen(true)
                  }}
                >
                  <img src={photo.src} alt={photo.alt} />
                </div>
              </div>
              <div className='photo-item-text'>
                {photo.title && <div className='photo-item-title'>{photo.title}</div>}
                {photo.subtitle && <div className='photo-item-subtitle'>{photo.subtitle}</div>}
              </div>
            </div>
          )
        })}
      </div>
      {maxPhotos && maxPhotos > 0 && <div className='show-more' onClick={() => setIsHidden(!isHidden)}>Show {isHidden ? 'More' : 'Less'}</div>}
      <Lightbox
        {...props}
      />
    </>
  )
}

// const DisplayPhoto = ({ photo }) => {
//   return (
//     <div className='display-photo-section' style={{
//       backgroundImage: `url(${photo.url || ''})`
//     }}>
//       <div className='overlay'></div>
//       { photo.alt && <h2 className='overlay-text'>{photo.alt}</h2> }
//     </div>
//   )
// }

const FullWidthQuote = ({ quote }) => {
  return (
    <div className='full-width-section full-width-quote'>
      <div className='full-width-quote-text'>{quote}</div>
    </div>
  )
}

const FullWidthDisplayPhoto = ({ photo, isMobile }) => {
  return (
    <div className='full-width-section'>
      <img src={isMobile && photo.mobileUrl ? photo.mobileUrl : photo.url} alt={photo.alt} />
    </div>
  )
}

const Main = () => {
  const { isMobile, isLandscape, isMobileDevice, isSmallScreen } = useOutletContext()
  const [showTrailer, setShowTrailer] = useState(false)
  const [showMoreTextAboutHillary, setShowMoreTextAboutHillary] = useState(true)
  const [showMoreTextAboutFilm, setShowMoreTextAboutFilm] = useState(true)
  useEffect(() => {
    if (isMobileDevice || isSmallScreen) {
      setShowMoreTextAboutFilm(false);
      setShowMoreTextAboutHillary(false);
    }
  }, [isMobileDevice, isSmallScreen]);

  return (
    <>
      <div className='App'>
        <Trailer setShowTrailer={setShowTrailer} isMobile={isMobile} isLandscape={isLandscape} />
        <div className='content'>
          <main>
            <FullWidthQuote quote='Transcends borders and inspires action and hope towards climate sustainability for future generations' />
            <section id='about'>
              <div className='content-container'>
                <h2>About this film</h2>
                <p>This short documentary ‘The Girl and Her Piano' chronicles the extraordinary journey of Hillary O'Sullivan, then 12-year-old Singaporean pianist and climate ambassador, who was invited to perform at Bhutan's Royal Highland Festival in October 2023 for His Majesty, the King of Bhutan. Hillary is the first foreigner and youngest performer,  to be invited to participate in the festival since its inception in 2016.</p>
                <p>Shot in the remote village of Laya at 4000 metres, ‘The Girl and Her Piano’ will highlight the urgent environmental issues confronting the Himalayan region, with a focus on the environmental threat to the glaciers of Bhutan. Despite being the world's first declared carbon-negative nation, Bhutan faces increasing threats from climate change, including glacial melt, flash floods, and unpredictable weather patterns.</p>
                {showMoreTextAboutFilm && (<><p>Playing the piano since she was 3, Hillary is committed to advocating for climate awareness through music, and has performed in diverse locations, including Bunaken Island in Sulawesi, Fenfushi Island in the Maldives and a performance in Antarctica during the Antarctic Climate Expedition in February 2023.</p>
                <p>“Himalayan glaciers could lose up to 80% of their ice by the year 2100 due to global warming,” Hillary explains in the film's narration. “I can feel that the need for climate resilience and sustainability is urgent. As part of the younger generation, I sometimes feel small compared to the huge problem we are facing.”</p></>)}
                {isMobile && <div className='show-more' onClick={() => setShowMoreTextAboutFilm(!showMoreTextAboutFilm)}>Show {showMoreTextAboutFilm ? 'Less' : 'More'}</div>}
              </div>
            </section>
            <FullWidthDisplayPhoto
              isMobile={isMobile}
              photo={{
              url: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/full_width_desktop_1_110a7512c2.jpeg',
              mobileUrl: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/Girl-and-Her-Piano-Documentary-Climate-Change-full1.jpeg'
            }} />
            <section id='about-hillary'>
              <div className='content-container'>
                <h2>About Hillary</h2>
                <p>Hillary is an accomplished young Singaporean pianist, and her musical journey began at the tender age of 3. An 11-times award-winning classical pianist, she has travelled to remote islands in Indonesia and Maldives, and surrounded by children and their parents, she performed in open air concerts to the sounds of nature.</p>
                <p>Hillary also has a deep love for photography, which led to her 2018 photo-documentary “Above the Sands”, on the people of Bunaken, Indonesia. Focusing on the people of Bunaken, she interviewed and photographed the villagers from all walks of life to gain a deeper understanding of their culture.</p>
                {showMoreTextAboutHillary && (
                  <>
                  <p>In 2023, she was invited to participate in the Antarctic Climate Expedition, and she made the long journey to Antarctica as the youngest Key Opinion Ambassador of the expedition. 'Rhapsody of a Changing Antarctic' was specially composed for the expedition, and Hillary's role was to play the music in an attempt to inspire collective action against climate change.</p>
                  <p>Since coming back from Antarctica, Hillary has been interviewed live by CNA on TV News, as well as by Today Online about her efforts to use music to highlight the perils of climate change. She conducted interviews of climate experts and activists during the Antarctic trip, and presented her findings to her school in Singapore, so as to share and advocate for climate awareness with her peers.</p>
                  <p>Hillary was invited to perform 'Rhapsody of a Changing Antarctic' at the Royal Highland Festival in 2023. His Majesty The King has envisioned the Royal Highland Festival in 2016 to preserve and celebrate the highland culture and traditions of Bhutan while contributing to their socio-economic development. The Festival aims to showcase Bhutan's highland culture while promoting Bhutan's efforts around climate resilience. Hillary's participation benefited the Festival and the larger Highland Sustainability Initiative in promoting its message on climate change and sustainability for Bhutan.</p>
                  </>
                )}
                {isMobile && <div className='show-more' onClick={() => setShowMoreTextAboutHillary(!showMoreTextAboutHillary)}>Show {showMoreTextAboutHillary ? 'Less' : 'More'}</div>}
              </div>
            </section>
            <FullWidthDisplayPhoto
              isMobile={isMobile}
              photo={{
              url: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/full_width_desktop_2_bdc2e93dc3.jpeg',
              mobileUrl: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/Girl-and-Her-Piano-Documentary-Climate-Change-full2.jpeg'
            }} />
            <section id='gallery'>
              <div className='content-container'>
                <h2>Photos</h2>
                <PhotoGrid photos={galleryPhotos} maxPhotos={9} isMobile={isMobile} />
              </div>
            </section>
            <FullWidthDisplayPhoto
              isMobile={isMobile}
              photo={{
              url: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/full_width_desktop_3_923f899b35.jpeg',
              mobileUrl: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/Girl-and-Her-Piano-Documentary-Climate-Change-full4.jpeg'
            }} />
            <section id='cast'>
              <div className='content-container'>
                <h2>Cast, Crew and Partners</h2>
                <PhotoGrid photos={castPhotos}
                isMobile={isMobile}
                renderPhoto={({ slide, items }) => (
                  <PhotoWithContent slide={slide} items={castPhotos} isMobile={isMobile} />
                )} />
              </div>
            </section>
            <section id='contact'>
              <div className='content-container'>
                <h2>Contact</h2>
                <ContactForm />
                <p>For more information, please <a style={{ textDecoration: 'underline' }} href='mailto:info@thegirlandherpiano.com'>email us</a></p>
              </div>
            </section>
          </main>
        </div>
        <footer className='footer'>
          <div className='content-container'>
            <a href='https://www.instagram.com/thegirlandherpiano' target='_blank' rel='noopener noreferrer' style={{ display: 'inline-block' }}>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                <rect x='2' y='2' width='20' height='20' rx='5' ry='5'></rect>
                <path d='M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z'></path>
                <line x1='17.5' y1='6.5' x2='17.51' y2='6.5'></line>
              </svg>
            </a>
            <a href='https://www.facebook.com/thegirlandherpiano' target='_blank' rel='noopener noreferrer' style={{ display: 'inline-block' }}>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='currentColor' stroke='currentColor' strokeWidth='0.5' strokeLinecap='round' strokeLinejoin='round'>
                <path d='M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z'></path>
              </svg>
            </a>
            <a href='mailto:info@thegirlandherpiano.com' target='_blank' rel='noopener noreferrer' style={{ display: 'inline-block', marginRight: '5px' }}>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
              <path d='M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z'></path>
              <polyline points='22,6 12,13 2,6'></polyline>
            </svg>
          </a>
            <p>© 2024 White Room Studio Pte Ltd. All rights reserved.</p>
          </div>
        </footer>
      </div>
      <Lightbox
        open={showTrailer}
        close={() => setShowTrailer(false)}
        plugins={[Video]}
        slides={[
          {
            type: 'video',
            width: 1280,
            height: 720,
            poster: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/header-bg.jpg',
            sources: [
              {
                src: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/trailer.mp4',
                type: 'video/mp4',
              },
            ],
          },
        ]}
      />
    </>
  )
}

export default Main